import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconPerson: React.FC<Props> = ({
  width = 18,
  height = 18,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.9167 8.95833C17.9167 4.01833 13.8983 0 8.95833 0C4.01833 0 0 4.01833 0 8.95833C0 11.85 1.3825 14.4184 3.51583 16.0575C3.51916 16.0609 3.52419 16.0625 3.52753 16.0659C5.03669 17.2217 6.91581 17.9167 8.95915 17.9167C11.0025 17.9167 12.8817 17.2217 14.3909 16.0659C14.3942 16.0625 14.3991 16.0609 14.4025 16.0575C16.5341 14.4184 17.9167 11.85 17.9167 8.95833ZM1.25 8.95833C1.25 4.7075 4.7075 1.25 8.95833 1.25C13.2092 1.25 16.6667 4.7075 16.6667 8.95833C16.6667 11.0608 15.8183 12.9684 14.4483 14.36C14.0742 12.7759 12.8766 11.3083 10.3833 11.3083H7.53337C5.04003 11.3083 3.84166 12.7759 3.46832 14.36C2.09832 12.9684 1.25 11.0608 1.25 8.95833ZM4.59086 15.3033C4.63919 14.4483 5.03003 12.5583 7.53337 12.5583H10.3833C12.8866 12.5583 13.2775 14.4483 13.3258 15.3033C12.0833 16.1617 10.5792 16.6667 8.95833 16.6667C7.3375 16.6667 5.83336 16.1608 4.59086 15.3033ZM8.96505 10.4167C10.6875 10.4167 12.09 9.015 12.09 7.29167C12.09 5.56833 10.6875 4.16667 8.96505 4.16667C7.24255 4.16667 5.84005 5.56833 5.84005 7.29167C5.84005 9.015 7.24171 10.4167 8.96505 10.4167ZM8.96505 5.41667C9.99838 5.41667 10.84 6.2575 10.84 7.29167C10.84 8.32583 9.99838 9.16667 8.96505 9.16667C7.93171 9.16667 7.09005 8.32583 7.09005 7.29167C7.09005 6.2575 7.93171 5.41667 8.96505 5.41667Z" fill="#3E454D"/>
  </svg>
);

export default IconPerson;
